<template>
	<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<rect width="20" height="20"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0L10.5 1H14V3H0V1H3.5L4.5 0H9.5ZM1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3 6H11V16H3V6Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>